import Content from 'components/Content/Content';
import { withEnhancedContentProps } from 'viewModel/enhancedContent/withEnhancedContentProps';

export default withEnhancedContentProps(Content);
